module.exports = __webpack_public_path__ + "img/desc4.b5253bfa.jpg";